var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('h1',[_vm._v("发展大事记")]),_c('p',[_vm._v("Development events")]),_c('div',[_c('svgs',{attrs:{"id":"svg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }